import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

const PAIAManualPage = () => {
  return (
    <main className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50 py-12">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
          PAIA Manual
        </h1>
        <p className="text-gray-600 mb-8">
          Promotion of Access to Information Act (Act 2 of 2000) Manual
        </p>

        <Card>
          <CardContent className="p-8 prose prose-emerald max-w-none">
            <h2>1. Introduction</h2>
            <p>
              This manual is published in terms of Section 51 of the Promotion of Access to 
              Information Act, 2000 (Act No. 2 of 2000) ("PAIA"). The purpose of PAIA is to 
              give effect to the constitutional right of access to any information held by 
              the State and any information held by another person that is required for the 
              exercise or protection of any rights.
            </p>

            <h2>2. Company Details</h2>
            <p>
              <strong>Name:</strong> Flippy Homes (Pty) Ltd<br/>
              <strong>Registration Number:</strong> [Registration Number]<br/>
              <strong>Physical Address:</strong> South Africa<br/>
              <strong>Postal Address:</strong> South Africa<br/>
              <strong>Telephone:</strong> +27 65 524 9286<br/>
              <strong>Email:</strong> info@flippyhomes.co.za
            </p>

            <h2>3. Information Officer</h2>
            <p>
              <strong>Name:</strong> Information Officer<br/>
              <strong>Email:</strong> paia@flippyhomes.co.za<br/>
              <strong>WhatsApp:</strong> +27 65 524 9286
            </p>

            <h2>4. Guide on How to Use PAIA</h2>
            <p>
              The South African Human Rights Commission (SAHRC) has compiled a guide containing 
              information to assist persons wishing to exercise their rights in terms of PAIA. 
              The guide is available from the SAHRC at:
            </p>
            <p>
              <strong>Website:</strong> www.sahrc.org.za<br/>
              <strong>Email:</strong> paia@sahrc.org.za
            </p>

            <h2>5. Records Held by Flippy Homes</h2>
            <p>The following categories of records are held by Flippy Homes:</p>
            
            <h3>5.1 Company Records</h3>
            <ul>
              <li>Registration documents</li>
              <li>Memorandum of Incorporation</li>
              <li>Minutes of meetings</li>
              <li>Financial statements</li>
            </ul>

            <h3>5.2 Human Resources Records</h3>
            <ul>
              <li>Employment contracts</li>
              <li>Personnel files</li>
              <li>Disciplinary records</li>
              <li>Training records</li>
            </ul>

            <h3>5.3 Client Records</h3>
            <ul>
              <li>User account information</li>
              <li>Property listing data</li>
              <li>Transaction records</li>
              <li>Correspondence</li>
            </ul>

            <h3>5.4 Financial Records</h3>
            <ul>
              <li>Accounting records</li>
              <li>Banking records</li>
              <li>Tax records</li>
              <li>Insurance records</li>
            </ul>

            <h2>6. Request Procedure</h2>
            <p>
              A person requesting access to a record of Flippy Homes must complete the 
              prescribed form (Form C) and submit it to the Information Officer. The form 
              must be accompanied by the prescribed request fee.
            </p>
            <p>
              The Information Officer will respond to the request within 30 days. If the 
              request is granted, a further access fee may be payable.
            </p>

            <h2>7. Grounds for Refusal</h2>
            <p>
              PAIA sets out various grounds on which a request for information may be refused. 
              These include:
            </p>
            <ul>
              <li>Protection of privacy of a third party</li>
              <li>Protection of commercial information</li>
              <li>Protection of confidential information</li>
              <li>Legal privilege</li>
              <li>Safety of individuals</li>
            </ul>

            <h2>8. Remedies</h2>
            <p>
              If a request for access to information is refused, the requester may lodge an 
              internal appeal within 60 days. If the internal appeal is unsuccessful, the 
              requester may apply to a court for appropriate relief.
            </p>

            <h2>9. Availability of the Manual</h2>
            <p>
              This manual is available on our website at flippyhomes.co.za/paia-manual and 
              at our offices during normal business hours.
            </p>

            <h2>10. Updates</h2>
            <p>
              This manual will be updated from time to time as required by law or as our 
              business practices change.
            </p>
          </CardContent>
        </Card>
      </div>
    </main>
  );
};

export default PAIAManualPage;
